import { MenuItemsType, DropdownMenuItemType } from '@pancakeswap/uikit'
import { ContextApi } from 'contexts/Localization/types'
import { nftsBaseUrl } from 'views/Nft/market/constants'

export type ConfigMenuItemsType = MenuItemsType & { hideSubNav?: boolean }

const config: (t: ContextApi['t']) => ConfigMenuItemsType[] = (t) => [
  {
    label: t('Trade'),
    icon: 'Swap',
    href: '/swap',
    // href: 'https://donutswap.finance/swap',

    hideSubNav:true,
    type: DropdownMenuItemType.EXTERNAL_LINK,
    // showItemsOnMobile: false,
    items: [
      {
        label: t('Swap'),
        // href: '/swap',
        href: 'https://donutswap.finance/swap',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
      {
        label: t('Liquidity'),
        // href: '/liquidity',
        href: 'https://donutswap.finance/liquidity',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
    ],
  },
  {
    label: t('Earn'),
    href: '/farms',
    hideSubNav:true,
    // href: 'https://donutswap.finance/farms',
    type: DropdownMenuItemType.EXTERNAL_LINK,

    icon: 'Earn',
    items: [
      {
        label: t('Farms'),
        // href: '/farms',
        href: 'https://donutswap.finance/farms',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
      {
        label: t('Pools'),
        // href: '/farms',
        href: 'https://donutswap.finance/pools',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
      {
        label: t('Positions'),
        // href: '/pools',
        href: 'https://donutswap.finance/positions',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
      {
        label: t('YUM Pools'),
        // href: '/pools',
        href: 'https://donutswap.finance/yumpools',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },

    ],
  },
  {
    label: t('YUM'),
    href: '/yum',
    hideSubNav:true,
    type: DropdownMenuItemType.EXTERNAL_LINK,
    // onClick:() => {window.location.href="https://donutswap.finance/yum"},
    icon: 'Proposal',
    items: [
      {
        label: t('Yum'),
        href: 'https://donutswap.finance/yum',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
      {
        label: t('Dividends'),
        href: 'https://donutswap.finance/dividends',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
      {
        label: t('Launchpad'),
        href: 'https://donutswap.finance/launchpad',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
      {
        label: t('Yield Booster'),
        href: 'https://donutswap.finance/yieldbooster',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
    ],
  },
  // {
  //   label: t('Bakery'),
  //   href: '/bakery',
  //   hideSubNav:true,
  //   // type: DropdownMenuItemType.EXTERNAL_LINK,
  //   icon: 'Nft',
  //   items: [
     
  //   ],
  // },
  {
    label: t('Analytics'),
    href: '/info',
    hideSubNav:true,
    icon: 'Info',
    items: [
      {
        label: t('Overview'),
        href: '/info',
      },
      {
        label: t('Pools'),
        href: '/info/pools',
      },
      {
        label: t('Tokens'),
        href: '/info/tokens',
      },
    ],
  },
  // {
  //   label: t('More'),
  //   href: '/',
  //   icon: 'Nft',
  //   hideSubNav:true,
  //   items: [
  //     {
  //       label: t('Margin Trading'),
  //       href: 'http://dsp.maticz.in/',
  //       type: DropdownMenuItemType.EXTERNAL_LINK,

  //     }
    
     
     
  //   ],
  // },
  // {
  //   label: t('NFT'),
  //    href: '/nft',
  //   icon: 'Voting'
  
  // },
  // {
  //   label: t('NFT'),
  //   href: '/nft',
  //   icon: 'Nft',
  //   showItemsOnMobile: false,
  //   items: [

  //   ],
  // },
  // {
  //   label: t('Referral'),
  //   href: '/referral',
  //   icon: 'Referral',
  //   items: [
  //
  //   ],
  // },
  // {
  //   label: t('Ido'),
  //   href: '/ido',
  //   icon: 'Ido',
  //   items: [

  //   ],
  // },

]

export default config
